import type { MbcBriefQuality } from "@nlc/shared-types";

import { scoreColor } from "@/utils/scoreColor";

/** Quality of a brief that has no request behind it yet, so nothing to judge. */
export const NOT_STARTED_QUALITY: MbcBriefQuality = {
  band: "poor",
  canSubmit: false,
  items: [],
  score: 0,
};

type BriefScoreSummary = {
  color: string | undefined;
  /** Some criterion is still being judged, so the score is not final. */
  isJudging: boolean;
  notStarted: boolean;
  score: null | number;
};

export function briefScoreSummary(
  quality: MbcBriefQuality | null,
): BriefScoreSummary {
  const notStarted =
    quality?.items.every((item) => item.status === "unanswered") ?? false;
  const isJudging =
    quality?.items.some((item) => item.status === "pending") ?? false;

  if (notStarted || !quality) {
    return {
      color: undefined,
      isJudging,
      notStarted,
      score: notStarted ? 0 : null,
    };
  }

  return {
    color: scoreColor(quality.score),
    isJudging,
    notStarted,
    score: quality.score,
  };
}
